import React from 'react';
import { GENERIC_FILTER_TEMPLATES_QUERY } from '../queries';
import { Card } from '@totalsoft/rocket-ui';
import GenericFilterTemplateItemComponent from './GenericFilterTemplateItemComponent';
import { getListBrowserStore } from '@ts-private/list-browser';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ExportModalComponent } from 'components/common/export/ExportModalComponent';
import { useMemo } from 'react';
import TableListBrowser from 'features/common/components/table-list-browser/TableListBrowser';
import ApolloFetchingComponent from 'features/common/components/apollo-fetching/ApolloFetchingComponent';

export const genericFilterTemplatesStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'isTemplate',
      caption: 'GenericFilterTemplate.IsTemplate',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'GenericFilterTemplate.Name',
      value: 'TemplateName'
    }
  ],
  pager: {
    orderBy: 'TemplateName',
    direction: 'asc'
  }
});

const GenericFilterTemplatesListBrowser = () => {
  const fetchingOptions = useMemo(
    () => ({
      queryOptions: {
        query: GENERIC_FILTER_TEMPLATES_QUERY,
        name: 'genericFilterTemplates'
      }
    }),
    []
  );

  const columns = useMemo(
    () => [
      { name: 'name', caption: 'GenericFilterTemplate.Name' },
      { name: 'filterCondition', caption: 'GenericFilterTemplate.FilterCondition' },
      { name: 'isTemplate', caption: 'GenericFilterTemplate.IsTemplate', width: 20, align: 'center' },
      { name: 'actions', caption: 'GenericFilterTemplate.Actions', width: '100px' }
    ],
    []
  );

  return (
    <Card icon={ListAltIcon}>
      <TableListBrowser
        name='generic-filter-templates-browser'
        store={genericFilterTemplatesStore}
        ItemComponent={GenericFilterTemplateItemComponent}
        columns={columns}
      />
      <ExportModalComponent store={genericFilterTemplatesStore} options={fetchingOptions} />
      <ApolloFetchingComponent store={genericFilterTemplatesStore} options={fetchingOptions} />
    </Card>
  );
};

export default GenericFilterTemplatesListBrowser;
